<template>
  <div class="quote-item__product">
    <div class="quote-item__product-name">
      {{ name }} x{{ quantity }}
    </div>
    <div class="quote-item__cost">
      Cost: {{ formatPrice(cost) }}
    </div>
  </div>
</template>

<script>
import { EcommerceModule } from "spiritweb.packages.ecommerce";

export default {
  name: "QuoteItemProduct",
  props: {
    name: {
      type: String,
      required: true
    },
    quantity: {
      type: Number,
      default: 1
    },
    cost: {
      type: Number,
      default: 0
    }
  },
  methods: {
    formatPrice ( price ) {
      return EcommerceModule.renderPrice( price, "gbp", "en-gb" );
    }
  }
};
</script>

<style lang="less" scoped>

.quote-item__product {
  @media screen and ( min-width: 768px ) {
    padding-right: 30px;
  }

  &-name {
    font-weight: 600;
  }

}
</style>
